import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'

@Injectable({
  providedIn: 'root'
})
export class StaticService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    getStaticPageByCode(code: string): any {
        return this.http.get(this.common.apiServiceURL + 'Static/getStaticPageByCode?code=' + code);
    }

}
